<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.post')"
    namespace=""
    resource="posts"
    :actionColumnProps="{ width: 260 }"
    :onFetchData="onFetchData"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { POST_PUBLISHER_TYPE } from '@/constants';
import _ from 'lodash';

@Component
export default class Posts extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  topicOptions = []
  merchantOptions = []
  productOptions = []

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/posts', { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/posts/${this.$route.params.id}`);
      this.topicOptions = _.map(data.topics, t => ({ value: t.id, label: t.name }))
      this.merchantOptions = _.map(data.merchants, t => ({ value: t.id, label: t.name }))
      this.productOptions = _.map(data.products, t => ({ value: t.id, label: t.name }))
      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'title_cont',
        label: this.$t('post.title'),
        renderCell: {
          component: 'input'
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const isMerchantRole = this.$root.user.current_role.role.kind === 'merchant'

    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'title',
        label: this.$t('post.title'),
      },
      {
        prop: 'published_at',
        label: this.$t('post.publishStatus'),
        renderCell: 'bool',
      },
      !isMerchantRole && {
        prop: 'publisher',
        label: this.$t('post.publisher'),
        renderCell: (h, { props: { value } }) => {
          return <bean-link keepNode to={{ name: `${value.tn}.show`, params: { id: value.id } }}>{_.get(value, 'name', value.id)}</bean-link>
        }
      },
      {
        prop: 'likes_count',
        label: this.$t('post.likesCount'),
      },
      type === 'show' && {
        prop: 'topics',
        label: this.$t('model.topic'),
        renderCell: (h, { props: { value } }) => {
          return <div>{_.map(value, v => <div><bean-link keepNode to={{ name: 'topics.show', params: { id: v.id } }}>{_.get(v, 'name', v.id)}</bean-link></div>)}</div>
        }
      },
      type === 'show' && {
        prop: 'merchants',
        label: this.$t('model.merchant'),
        renderCell: (h, { props: { value } }) => {
          return <div>{_.map(value, v => <div><bean-link keepNode to={{ name: 'merchants.show', params: { id: v.id } }}>{_.get(v, 'name', v.id)}</bean-link></div>)}</div>
        }
      },
      type === 'show' && {
        prop: 'products',
        label: this.$t('model.product'),
        renderCell: (h, { props: { value } }) => {
          return <div>{_.map(value, v => <div><bean-link keepNode to={{ name: 'products.show', params: { id: v.id } }}>{_.get(v, 'name', v.id)}</bean-link></div>)}</div>
        }
      },
      type === 'show' && {
        prop: 'mini_program_path',
        label: this.$t('post.miniProgramPath'),
      },
      type === 'show' && {
        prop: 'medium',
        label: this.$t('post.medium'),
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'share_desc',
        label: this.$t('post.shareDesc')
      },
      type === 'show' && {
        prop: 'share_image',
        label: this.$t('post.shareImage'),
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'poster_image',
        label: this.$t('post.posterImage'),
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'infographic',
        label: this.$t('post.infographic'),
        renderCell: 'html',
      },
      type === 'show' && {
        prop: 'created_at',
        label: this.$t('createdAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
      type === 'show' && {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const isMerchantRole = this.$root.user.current_role.role.kind === 'merchant'

    return [
      {
        prop: 'title',
        label: this.$t('post.title'),
        renderCell: {
          component: 'input',
          required: true
        }
      },
      !isMerchantRole && {
        prop: 'publisher_type',
        label: this.$t('post.publisherType'),
        renderCell: {
          required: true,
          component: 'select',
          hint: this.$t('hints.disallowEditAfterCreate'),
          props: {
            options: _.map(POST_PUBLISHER_TYPE, (value) => ({ label: this.$t(`post.publisherTypes.${value}`), value: value })),
            disabled: type === 'edit',
          }
        }
      },
      data.publisher_type === 'Merchant' && !isMerchantRole && {
        prop: 'publisher_id',
        label: this.$t('post.publisher'),
        renderCell: {
          required: true,
          component: 'select',
          hint: this.$t('hints.disallowEditAfterCreate'),
          props: {
            disabled: type === 'edit',
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/merchants', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/merchants', { params });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            }
          }
        }
      },
      {
        prop: 'topic_ids',
        label: this.$t('model.topic'),
        renderCell: {
          component: 'select',
          props: {
            multiple: true,
            options: this.topicOptions,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/topics', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/topics', { params });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            }
          }
        }
      },
      {
        prop: 'merchant_ids',
        label: this.$t('model.merchant'),
        renderCell: {
          component: 'select',
          props: {
            multiple: true,
            options: this.merchantOptions,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/merchants', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/merchants', { params });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            }
          }
        }
      },
      {
        prop: 'product_ids',
        label: this.$t('model.product'),
        renderCell: {
          component: 'select',
          props: {
            multiple: true,
            options: this.productOptions,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/products', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/products', { params });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            }
          }
        }
      },
      {
        prop: 'medium',
        label: this.$t('post.medium'),
        renderCell: {
          component: 'upload',
          required: true,
          hint: `${this.$t('suggestSize')}: 750x422`,
          props: {
            cropper: {
              width: 750,
              height: 422
            }
          }
        }
      },
      {
        prop: 'share_desc',
        label: this.$t('post.shareDesc'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'share_image',
        label: this.$t('post.shareImage'),
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 500:400`,
          props: {
            cropper: {
              width: 500,
              height: 400
            }
          }
        }
      },
      {
        prop: 'poster_image',
        label: this.$t('post.posterImage'),
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 600x509`,
          props: {
            cropper: {
              width: 600,
              height: 509
            }
          }
        }
      },
      {
        prop: 'infographic',
        label: this.$t('post.infographic'),
        renderCell: {
          component: 'editor',
          required: true
        }
      },
    ]
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const togglePublishAction = row.published_at ? 'unpublish' : 'publish'
    const handleTogglePublish = async () => {
      await this.$autoLoading(this.$request.put(`/posts/${row.id}/${togglePublishAction}`));
      this.$message.success(this.$t('bean.updateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'posts.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: `${row.published_at ? this.$t('post.cancelPublish') : this.$t('post.publish')}`,
          type: 'primary',
          can: 'posts.publish'
        },
        on: {
          confirm: handleTogglePublish
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'posts.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

}


export const route = [
  {
    path: '/posts',
    name: 'posts.index',
    component: Posts,
    props: {
      type: 'index',
    }
  },
  {
    path: '/posts/new',
    name: 'posts.new',
    component: Posts,
    props: {
      type: 'new',
    }
  },
  {
    path: '/posts/:id',
    name: 'posts.show',
    component: Posts,
    props: {
      type: 'show',
    }
  },
  {
    path: '/posts/:id/edit',
    name: 'posts.edit',
    component: Posts,
    props: {
      type: 'edit'
    }
  }
]
</script>
